import React from 'react';

function Field({ q, value, onChange }) {
  const base =
    'w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 focus:border-emerald-500 focus:outline-none dark:border-slate-600 dark:bg-slate-800 dark:text-white';
  if (q.input_type === 'textarea') {
    return <textarea rows={3} className={base} value={value} onChange={(e) => onChange(e.target.value)} />;
  }
  if (q.input_type === 'select') {
    return (
      <select className={base} value={value} onChange={(e) => onChange(e.target.value)}>
        <option value="">Skip / not sure</option>
        {q.options.map((o) => (
          <option key={o} value={o}>{o}</option>
        ))}
      </select>
    );
  }
  return (
    <input
      type={q.input_type === 'date' ? 'date' : 'text'}
      className={base}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}

export function QuestionsForm({ category, answers, setAnswers, onBack, onNext }) {
  return (
    <div>
      <h2 className="mb-1 text-lg font-semibold text-slate-900 dark:text-white">{category.title}</h2>
      <p className="mb-4 text-sm text-slate-600 dark:text-slate-300">
        Answer what you can — skip anything you don&apos;t know.
      </p>
      <div className="space-y-4">
        {category.questions.map((q) => (
          <label key={q.field_key} className="block">
            <span className="mb-1 block text-sm font-medium text-slate-700 dark:text-slate-200">
              {q.label}
            </span>
            <Field
              q={q}
              value={answers[q.field_key] || ''}
              onChange={(v) => setAnswers({ ...answers, [q.field_key]: v })}
            />
          </label>
        ))}
      </div>
      <div className="mt-6 flex justify-between">
        <button type="button" onClick={onBack} className="rounded-lg px-4 py-2 text-sm font-medium text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-800">
          Back
        </button>
        <button type="button" onClick={onNext} className="rounded-lg bg-emerald-600 px-5 py-2 text-sm font-semibold text-white hover:bg-emerald-700">
          Next: choose a tone
        </button>
      </div>
    </div>
  );
}
